import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { BUTTON_MAX_HEIGHT } from '../../../../components/selectable-button/constants';

export const VariantGroupWrapper = styled.div`
  ${media.mediumDown`
    margin: 0 -${layout.pageContent.gutter.rem};
  `}
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 2px;
  margin-top: ${layout.measurements.spacingTiny};

  ${media.mediumDown`
    margin: 0;
    padding: 0;
    padding-bottom: 2px;
    flex-wrap: nowrap;
    overflow-x: auto;

    > :first-child {
      margin-left: ${layout.measurements.spacingSmall};
    }

    > :last-child {
      margin-right: ${layout.measurements.spacingSmall};
    }
  `}
`;

type ColorProps = {
  variantData: string;
};

export const Color = styled.div<ColorProps>(
  props => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    border-radius: 12px;
    background: ${props.variantData};
    margin-right: ${layout.measurements.spacingSmall};

    svg {
      width: 18px;
      height: 18px;
      color: ${props.theme.colors.base0};
    }

    ${props.variantData === '#FFFFFF' && // Custom styling for color white
      css`
        border: 1px solid ${props.theme.colors.base300};

        svg {
          color: ${props.theme.colors.base900};
        }
      `}
  `
);

type ShowMoreProps = {
  order: number;
};

export const ShowMore = styled.button<ShowMoreProps>(
  props => css`
    height: ${BUTTON_MAX_HEIGHT}px;
    width: ${BUTTON_MAX_HEIGHT}px;
    border: 1px solid ${props.theme.colors.base200};
    padding: ${layout.measurements.spacingSmall};
    border-radius: 8px;
    margin-top: ${layout.measurements.spacingSmall};
    color: ${props.theme.colors.maybeBlue700};
    cursor: pointer;
    order: ${props.order};

    &:hover {
      background: ${props.theme.colors.base100};
    }
  `
);
